export default __webpack_public_path__ + "static/media/token_ewc.3e801287.svg";